<template>
    <div class="fin-container-fluid fin-mt-7">
        <div class="md:fin-flex">
            <div class="md:fin-flex-1">
                <div class="fin-flex fin-flex-col">
                    <div>
                        <nav class="fin-flex" aria-label="Breadcrumb">
                            <ol role="list" class="fin-flex fin-items-center fin-space-x-4 fin-mb-0">
                                <li>
                                    <div class="fin-flex">
                                        <a
                                            href="/admin/applications/"
                                            class="fin-text-sm fin-font-medium fin-text-gray-500 hover:fin-text-gray-700"
                                        >
                                            Applications
                                        </a>
                                    </div>
                                </li>
                                <li>
                                    <div class="fin-flex fin-items-center">
                                        <font-awesome-icon :icon="['fas', 'angle-right']" class="fin-text-gray-400" />
                                        <p class="fin-ml-4 fin-mb-0 fin-text-sm fin-font-bold fin-text-primary">
                                            #{{ application.ref_id }}
                                            <el-tooltip
                                                v-if="isPrivate"
                                                class="item"
                                                effect="dark"
                                                content="Application is Private"
                                                placement="top"
                                            >
                                                <font-awesome-icon :icon="['fas', 'shield-alt']" class="fin-text-red-500" />
                                            </el-tooltip>
                                        </p>
                                    </div>
                                </li>
                            </ol>
                        </nav>
                    </div>

                    <div class="fin-mt-3 md:fin-mt-4 fin-flex fin-items-center">

                        <h2 class="fin-flex-1 md:fin-flex-none fin-text-xl md:fin-text-2xl fin-font-bold fin-leading-7 fin-text-primary sm:fin-truncate sm:fin-text-3xl sm:fin-tracking-tight">
                            {{ _.get(applicant, "full_name", "New Applicant") || "New Applicant" }}
                        </h2>

                        <div class="md:fin-mt-0 md:fin-ml-4 fin-flex-shrink-0 md:fin-flex-shrink-0">

                            <el-tooltip class="item" effect="dark" content="Your Timeline" placement="top">
                                <el-button size="small" class="fin-btn-secondary" circle>
                                    <a class="fin-flex" :href="application.timeline_url" target="_blank" rel="noreferrer">
                                        <font-awesome-icon :icon="['fas', 'clock']" class="fin-text-white fa-xs" />
                                    </a>
                                </el-button>
                            </el-tooltip>

                            <el-tooltip v-if="_.get(applicant, 'cx_phone', false)" class="item" effect="dark" :content="applicant.phone" placement="top">
                                <el-button size="small" class="fin-btn-secondary fin-ml-1" circle @click="callApplicant(applicant.cx_phone)">
                                    <span class="fin-flex">
                                        <font-awesome-icon :icon="['fas', 'phone']" class="fin-text-white fa-xs" />
                                    </span>
                                </el-button>
                            </el-tooltip>

                            <el-tooltip v-if="_.get(applicant, 'email', false)" class="item" effect="dark" :content="applicant.email" placement="top">
                                <el-button size="small" class="fin-btn-secondary fin-ml-1" circle @click="sendEmail(applicant.email)">
                                    <span class="fin-flex">
                                        <font-awesome-icon :icon="['fas', 'envelope']" class="fin-text-white fa-xs" />
                                    </span>
                                </el-button>
                            </el-tooltip>
                        </div>
                    </div>
                </div>
            </div>
            <div class="fin-mt-3 fin-flex fin-items-center md:fin-mt-0 md:fin-flex-shrink-0">
                <app-stages></app-stages>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import appStages from "@tenant/app/tabs/partials/appStages"
import { finButton } from "@htmlElements"

export default {
    name: "AppTitle",

    components: {
        finButton,
        appStages,
    },

    data() {
        return {

        }
    },

    computed: {
        ...mapGetters({
            application: "appStore/application/get",
            applicant: "appStore/application/approved_loan_applicants/applicant/get",
        }),
        app() {
            return this.application
        },
        isPrivate() {
            return this.application.is_private
        },
        isClosed() {
            return this.application.is_closed
        }
    },

    mounted() {},

    methods: {
        sendEmail(email) {
            this.$bus.$emit("open-create-modal", {
                selected: "Send Message",
                contactEmail: email,
                defaultEmailTemplate: "New Blank Email",
            })
        },
        callApplicant(phone) {
            window.open(`tel:${phone}`, "_self")
        }
    },
}
</script>

<style lang="scss" scoped></style>
